





















import Vue from 'vue'
import { vxm } from '@/state/index'

export default Vue.extend({
  name: 'MainNav',
  components: {
  },
  data: () => ({
    showSnackBar: false,
  }),
  computed: {
    snackBar() {
      const snack = vxm.app.snackBar
      if (snack === null) {
        return {
          color: 'white',
          text: '',
        }
      }
      return {
        color: snack.color,
        text: snack.text,
      }
    },
  },
  watch: {
    snackBar(snackBar) {
      if (snackBar !== null) {
        this.showSnackBar = true
      }
    },
  },
})

